export const getOS = () => {
    const userAgent = navigator.userAgent;



    if (userAgent.includes("Windows")) {
        return "Windows";
    } else if (userAgent.includes("Mac")) {
        return "Mac";
    } else if (userAgent.includes("Linux")) {
        return "Linux";
    } else if (userAgent.includes("Android")) {
        return "Android";
    } else if (userAgent.includes("iPhone")) {
        return "iOS";
    } else {
        return "Unknown";
    }
};